import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import { WalletService } from "@/services";
import $thousandMask from "@/mixins/thousandMask";
import makeSecure from "@/components/MakeSecure";
import userCenter from "@/services/modules/market/userCenter";

export default {
  name: "dashboard-info-card",
  components: { makeSecure },
  props: [],
  mixins: [$thousandMask],
  data() {
    return {
      hideAssets: localStorage.getItem("secure") === "true",
      dashboardInfoLoader: true,
      totalWallet: {},
      top5Wallet: {}
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.userInfo.getters.GET_USER_INFO
      // wallets: types.wallets.getters.GET_NEW_WALLETS
    })
  },
  mounted() {
    this.setSecureValue(localStorage.getItem("secure") === "true");
    // this.getWalletService();
    // this.getTotalWallet();
    // this.getTop5Wallets()
    Promise.all([this.getTotalWallet(), this.getTop5Wallets()]).finally(() => {
      this.dashboardInfoLoader = false;
    });
  },
  methods: {
    ...mapActions({
      // setNewWallets: types.wallets.actions.SET_NEW_WALLETS,
      setSecureValue: types.secure.actions.SET_SECURE
    }),
    hideAllAssets() {
      this.hideAssets = !this.hideAssets;
      this.setSecureValue(this.hideAssets).then(() => {
        localStorage.setItem("secure", this.hideAssets);
      });
    },
    getTotalWallet() {
      return WalletService.TotalWallet().then(res => {
        this.totalWallet = res.data.data;
      });
    },
    getTop5Wallets() {
      return userCenter.top5WalletsService().then(res => {
        this.top5Wallet = res.data.data;
      });
    }
    // getWalletService() {
    //   WalletService.getWalletV4()
    //     .then(response => {
    //       this.setNewWallets(response.data.data);
    //     })
    //     .finally(() => {
    //       this.dashboardInfoLoader = false;
    //     });
    // }
  }
};
